import React, { useContext, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { AppBar, Button, IconButton, Menu, MenuItem, Toolbar, Typography } from "@material-ui/core";
import MoreVert from "@material-ui/icons/MoreVert";
import SupervisorAccount from "@material-ui/icons/SupervisorAccount";
import { AuthContext } from "../context/Auth/AuthContext";

export default function ManagerLayout({ children }) {
  const { user, handleLogout } = useContext(AuthContext);
  const location = useLocation();
  const [anchor, setAnchor] = useState(null);
  const close = () => setAnchor(null);
  return <div style={{ height: "100dvh", display: "flex", flexDirection: "column", background: "#f7f9fc" }}>
    <AppBar position="static" color="default" elevation={0} style={{ borderBottom: "1px solid #dce5df", background: "#fff" }}>
      <Toolbar style={{ minHeight: 58, gap: 10 }}>
        <SupervisorAccount color="primary" />
        <div style={{ flex: 1, minWidth: 0 }}>
          <Typography variant="subtitle1" style={{ fontWeight: 700 }} noWrap>{user.company?.name || "Supervisão e gerência"}</Typography>
          <Typography variant="caption" color="textSecondary" noWrap>{user.name} · Somente leitura</Typography>
        </div>
        <IconButton aria-label="Abrir menu de supervisão" aria-controls="manager-menu" aria-haspopup="true" onClick={event => setAnchor(event.currentTarget)}><MoreVert /></IconButton>
        <Menu id="manager-menu" anchorEl={anchor} open={Boolean(anchor)} onClose={close}>
          <MenuItem component={Link} to="/management" selected={location.pathname === "/management"} onClick={close}>Conversas supervisionadas</MenuItem>
          <MenuItem component={Link} to="/dashboard?view=ai-reports" selected={location.pathname === "/dashboard"} onClick={close}>Relatórios com IA</MenuItem>
          <MenuItem onClick={() => { close(); handleLogout(); }}>Sair</MenuItem>
        </Menu>
        <Button size="small" onClick={handleLogout}>Sair</Button>
      </Toolbar>
    </AppBar>
    <main style={{ flex: 1, minHeight: 0, overflow: "auto", display: "flex", flexDirection: "column" }}>{children}</main>
  </div>;
}
